import React from 'react';
import { Typography as AntdTypography, TypographyProps } from 'antd';

const TypographyTitle: typeof AntdTypography.Title = AntdTypography.Title;
const Typography: React.FunctionComponent<TypographyProps> = props => {
	return <AntdTypography {...props} />;
};

export { TypographyTitle };
export default Typography;

const { Link } = AntdTypography;

export { Link as TypographyLink };
